import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { DistintoAmbientalModel } from '../../models/distintivo-ambiental.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DistintivoAmbientalService extends BaseService<DistintoAmbientalModel>{

  tipo: string;
  urlBase: string;
  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.tipo = 'Distintivo Ambiental';
    this.urlBase = `${environment.baseApi}${environment.endPoints.maestras.base_maestra}${environment.endPoints.maestras.distintivoAmbiental}`;
   }
}
